var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { VIEW_BG_VIEW, VIEW_CONTENT_MOD } from "../../View";
import { OptionRoot } from '../OptionRoot';
var getBackgroundView = function (_a) {
    var active = _a.active, hovered = _a.hovered, disabled = _a.disabled;
    if (disabled) {
        return VIEW_BG_VIEW.normal;
    }
    if (active) {
        return VIEW_BG_VIEW.highlightDark;
    }
    if (hovered) {
        return VIEW_BG_VIEW.highlight;
    }
    return VIEW_BG_VIEW.normal;
};
export function createOptionContainerRenderer() {
    return function optionContainerRenderer(_a) {
        var control = _a.control, content = _a.content, active = _a.active, hovered = _a.hovered, disabled = _a.disabled, style = _a.style, rest = __rest(_a, ["control", "content", "active", "hovered", "disabled", "style"]);
        var ref = control.ref, controlProps = __rest(control, ["ref"]);
        return (React.createElement(OptionRoot, __assign({ style: style, backgroundView: getBackgroundView({
                active: active,
                hovered: hovered,
                disabled: disabled
            }), contentMod: VIEW_CONTENT_MOD.fill }, controlProps, { ref: ref, testId: rest['data-selector-id'] }), content));
    };
}
//# sourceMappingURL=optionContainerRenderer.js.map